import {DigitalRevisionMenuItem} from '../interfaces/digital-revision-menu-item';
import {ProxyTypeEnum} from '../interfaces/proxy-type-enum';
import {MenuItemTypeEnum} from '../interfaces/menu-item-type-enum';
import {CombinedMenuItemTypeEnum} from '../interfaces/combined-menu-item-type-enum';
import { MenuItemModel } from '../models/menu-item.model';

const sharedMenuBar: MenuItemModel[] = [
  {
    Text: 'Home',
    ImagePath: '/assets/images/landing/home.png',
    DestinationPage: '',
  },
  {
    Text: 'Your Questions',
    ImagePath: '/assets/images/landing/online-workbook.png',
    DestinationPage: 'combined-exam-practice-questions',
  },
  {
    Text: 'Quizzes',
    ImagePath: '/assets/images/landing/quick-quizzes.png',
    DestinationPage: 'combined-quick-quiz',
  },
  {
    Text: 'Videos',
    ImagePath: '/assets/images/landing/video-solutions.png',
    DestinationPage: 'combined-content-videos',
  },
  {
    Text: 'Extra Bits',
    ImagePath: '/assets/images/landing/pdfs.png',
    DestinationPage: 'extras',
  },
];

export const HomePageMenuItems: DigitalRevisionMenuItem[] = [
  {
    MenuItemType: MenuItemTypeEnum.CombinedExamPracticeQuestions,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Exam Practice Questions',
    ButtonURL: '',
    MixedOnlineTests: [
      {
        CombinedMenuItemType: CombinedMenuItemTypeEnum.Chemistry,
        MixedOnlineTestUrl: '_revisionhub_opc/SAFQ43B/SAFQ43B_Chem_DigitalWorkbook_v3',
        Proxy: ProxyTypeEnum.CFProxy,
      },
      {
        CombinedMenuItemType: CombinedMenuItemTypeEnum.Physics,
        MixedOnlineTestUrl: '_revisionhub_opc/SAFQ43B/SAFQ43B_Phys_DigitalWorkbook_v3',
        Proxy: ProxyTypeEnum.CFProxy,
      },
      {
        CombinedMenuItemType: CombinedMenuItemTypeEnum.Biology,
        MixedOnlineTestUrl: '_revisionhub_opc/SAFQ43B/SAFQ43B_Bio_DigitalWorkbook_v3',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],
    HasData: true,
    HeadingText: 'Exam Practice Questions',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>See how well you understand each section. Mark your answers with our examples.</p>' +
      '\n' +
      '<span>Questions marked:</span><br/>' +
      '<span>Biology: <strong>[[variable1]]</strong></span><br/>' +
      '<span>Chemistry: <strong>[[variable2]]</strong></span><br/>' +
      '<span>Physics: <strong>[[variable3]]</strong></span>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'All the questions from your book',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.CombinedQuickQuiz,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Maths Skills Quiz',
    ButtonURL: '',

    MixedOnlineTests: [
      {
        CombinedMenuItemType: CombinedMenuItemTypeEnum.Chemistry,
        MixedOnlineTestUrl: '_revisionhub_opc/SAFQ43B/SAFQ43B_Chem_MathsSkills_v2',
        Proxy: ProxyTypeEnum.CFProxy,
      },
      {
        CombinedMenuItemType: CombinedMenuItemTypeEnum.Physics,
        MixedOnlineTestUrl: '_revisionhub_opc/SAFQ43B/SAFQ43B_Phys_MathsSkills_v3',
        Proxy: ProxyTypeEnum.CFProxy,
      },
      {
        CombinedMenuItemType: CombinedMenuItemTypeEnum.Biology,
        MixedOnlineTestUrl: '_revisionhub_opc/SAFQ43B/SAFQ43B_Bio_MathsSkills_v2',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],

    HasData: true,
    HeadingText: 'Math Skills Quiz',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '' +
      "<p>Test yourself on the Maths Skills you\'ll need to help with each Paper.</p>\n" +
      '\n' +
      '<span>Questions answered:</span><br/>' +
      '<span>Biology: <strong>[[variable1]]</strong></span><br/>' +
      '<span>Chemistry: <strong>[[variable2]]</strong></span><br/>' +
      '<span>Physics: <strong>[[variable3]]</strong></span>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Extra practice on the tricky Maths bits',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.CombinedMistakesQuiz,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '#F0542C',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Your Mistakes Quiz',
    ButtonURL: 'mistakes-quiz',

    MixedOnlineTests: [
      {
        CombinedMenuItemType: CombinedMenuItemTypeEnum.Chemistry,
        MixedOnlineTestUrl: '_revisionhub_opc/SAFQ43B/SAFQ43B_Chem_MathsSkills_Mistakes_v1',
        Proxy: ProxyTypeEnum.CFProxy,
      },
      {
        CombinedMenuItemType: CombinedMenuItemTypeEnum.Physics,
        MixedOnlineTestUrl: '_revisionhub_opc/SAFQ43B/SAFQ43B_Phys_MathsSkills_Mistakes_v2',
        Proxy: ProxyTypeEnum.CFProxy,
      },
      {
        CombinedMenuItemType: CombinedMenuItemTypeEnum.Biology,
        MixedOnlineTestUrl: '_revisionhub_opc/SAFQ43B/SAFQ43B_Bio_MathsSkills_Mistakes_v1',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],

    HasData: true,
    HeadingText: 'Your Mistakes Quiz',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>The Maths Skills quiz questions you got wrong are here &mdash; have another go and conquer them once and for all!</p>\n' +
      '<p>Total questions stored: <strong>[[variable1]]</strong></p>\n' +
      '<p>Total questions answered: <strong>[[variable2]]</strong><br />\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Correct your wrong answers\n',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.CombinedVideoExplanations,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Watch solutions',
    MixedOnlineTests: [],
    ButtonURL: '',
    HasData: false,
    HeadingText: 'Video Solutions',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>Worked answer videos with lots of advice to help you scoop up every last mark.</p>\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Help with answering the questions',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    HowToUseThisBook: {
      Text: "We've put together lots of helpful information on how to get the most out of your Revision Guide. And if you've hit any snags, you'll find the answers you need here too.",
      VideoLink: 'https://www.youtube.com/embed/-TqrRoP-g9I?rel=0&modestbranding=1',
    },
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain : '',
      ContentRight: {
        ImageUrl: '/assets/images/useful-bits-toucan.png',
        AltText: 'Fun image of toucan peeking out from behind the useful PDFs',
      },
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        CombinedMenuItemType: CombinedMenuItemTypeEnum.Biology,
        Title: 'Video Solutions',
        Intro:
          "CGP\'s friendly experts are here to walk you through some of the exam-style questions in your book — have a go at the questions first and use these videos if you need a bit of extra help.",
        LeftSections: [
          {
            Header: 'Topic B1 — Cell Biology',
            Subcategories: [
              {
                Name: 'Cells',
                ShortName: 'Cells',
                Link: 'https://www.youtube.com/embed/T1Zi3IGx2xA?rel=0&modestbranding=1',
              },
              {
                Name: 'Microscopy',
                ShortName: 'Microscopy',
                Link: 'https://www.youtube.com/embed/6GEeA24WvCc?rel=0&modestbranding=1',
              },
              {
                Name: 'Osmosis',
                ShortName: 'Osmosis',
                Link: 'https://www.youtube.com/embed/u8Tpvrvzvgs?rel=0&modestbranding=1',
              },
              {
                Name: 'Exchange Surfaces',
                ShortName: 'Exchange-Surfaces',
                Link: 'https://www.youtube.com/embed/0zlD9IMyIRg?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic B2a — Organisation, Enzymes and Circulation\n',
            Subcategories: [
              {
                Name: 'Investigating Enzymatic Reactions',
                ShortName: 'Investigating-Enzymatic-Reactions',
                Link: 'https://www.youtube.com/embed/Rwq-8krRc5U?rel=0&modestbranding=1',
              },
              {
                Name: 'Circulatory System — Blood Vessels',
                ShortName: 'Circulatory-System-Blood-Vessels',
                Link: 'https://www.youtube.com/embed/3csl0dVkluM?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic B2b — Disease and Plant Organisation',
            Subcategories: [
              {
                Name: 'Transpiration and Translocation',
                ShortName: 'Transpiration-and-Translocation',
                Link: 'https://www.youtube.com/embed/MHNugNLgXS8?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic B3 — Infection and Response\n',
            Subcategories: [
              {
                Name: 'Fighting Disease — Drugs',
                ShortName: 'MFighting-Disease-Drugs',
                Link: 'https://www.youtube.com/embed/R4yzWwHeHVE?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic B4 — Bioenergetics',
            Subcategories: [
              {
                Name: 'Photosynthesis',
                ShortName: 'Photosynthesis',
                Link: 'https://www.youtube.com/embed/6CX99wnfhns?rel=0&modestbranding=1',
              },
            ],
          },
        ],
        RightSections: [
          {
            Header: 'Topic B5 — Homeostasis and Response',
            Subcategories: [
              {
                Name: 'Homeostasis',
                ShortName: 'Homeostasis',
                Link: 'https://www.youtube.com/embed/ZDhQje_gPcY?rel=0&modestbranding=1',
              },
              {
                Name: 'Investigating Reaction Times',
                ShortName: 'Investigating-Reaction-Time',
                Link: 'https://www.youtube.com/embed/1YBDx_VMqrA?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic B6a — DNA and Reproduction',
            Subcategories: [
              {
                Name: 'X and Y Chromosomes',
                ShortName: 'X-and-Y-Chromosomes',
                Link: 'https://www.youtube.com/embed/Vdx0wQpHzMU?rel=0&modestbranding=1',
              },
              {
                Name: 'Inherited Disorders',
                ShortName: 'Inherited-Disorders',
                Link: 'https://www.youtube.com/embed/y-JZtnOWl-c?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic B6b — Variation, Evolution and Classification',
            Subcategories: [
              {
                Name: 'Antibiotic-Resistant Bacteria',
                ShortName: 'Antibiotic-Resistant-Bacteria',
                Link: 'https://www.youtube.com/embed/Bh1DTSFtrx0?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic B7 — Ecology and Cycles',
            Subcategories: [
              {
                Name: 'Abiotic and Biotic Factors',
                ShortName: 'Abiotic-and-Biotic-Factors',
                Link: 'https://www.youtube.com/embed/qZ8loF4n7A0?rel=0&modestbranding=1',
              },
              {
                Name: 'Using Quadrats',
                ShortName: 'Using-Quadrats',
                Link: 'https://www.youtube.com/embed/PW6nXMXWu68?rel=0&modestbranding=1',
              },
              {
                Name: 'The Carbon Cycle',
                ShortName: 'The-Carbon-Cycle',
                Link: 'https://www.youtube.com/embed/WIzrqputy68?rel=0&modestbranding=1',
              },
            ],
          },
        ],
      },
      {
        CombinedMenuItemType: CombinedMenuItemTypeEnum.Chemistry,
        Title: 'Video Solutions',
        Intro:
          "CGP\'s friendly experts are here to walk you through some of the exam-style questions in your book — have a go at the questions first and use these videos if you need a bit of extra help.",
        LeftSections: [
          {
            Header: 'Topic C1a — Atoms, Elements, Compounds & Mixtures',
            Subcategories: [
              {
                Name: 'Elements',
                ShortName: 'Elements',
                Link: 'https://www.youtube.com/embed/do_UDkN6muQ?rel=0&modestbranding=1',
              },
              {
                Name: 'More Separation Techniques',
                ShortName: 'More-Separation-Techniques',
                Link: 'https://www.youtube.com/embed/5myYoJRmlfg?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic C1b — The Periodic Table',
            Subcategories: [
              {
                Name: 'Group 7 Elements',
                ShortName: 'Group-7-Elements',
                Link: 'https://www.youtube.com/embed/31cFhOo5vlQ?rel=0&modestbranding=1',
              },
              {
                Name: 'Group 0 Elements',
                ShortName: 'Group-0-Elements',
                Link: 'https://www.youtube.com/embed/yrZ37BeijZs?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic C2 — Bonding, Structure and Properties of Matter',
            Subcategories: [
              {
                Name: 'Simple Molecular Substances',
                ShortName: 'Simple-Molecular-Substances',
                Link: 'https://www.youtube.com/embed/5J3eThza_RM?rel=0&modestbranding=1',
              },
              {
                Name: 'Changing State',
                ShortName: 'Changing-State',
                Link: 'https://www.youtube.com/embed/liiWx0-IJq4?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic C3 — Qualitative Chemistry',
            Subcategories: [
              {
                Name: 'Concentrations of Solutions',
                ShortName: 'Concentrations-of-Solutions',
                Link: 'https://www.youtube.com/embed/I9sheD282WU?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic C4 — Chemical Changes',
            Subcategories: [
              {
                Name: 'Reactions of Acids',
                ShortName: 'Reactions-of-Acids',
                Link: 'https://www.youtube.com/embed/_O9_lfBTHnY?rel=0&modestbranding=1',
              },
              {
                Name: 'Reactions of Metals',
                ShortName: 'Reactions-of-Metals',
                Link: 'https://www.youtube.com/embed/L-GbO_8r2vM?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic C5 — Energy Changes',
            Subcategories: [
              {
                Name: 'Exothermic and Endothermic Reactions',
                ShortName: 'Exothermic-and-Endothermic-Reactions',
                Link: 'https://www.youtube.com/embed/f3pP4aUHkCk?rel=0&modestbranding=1',
              },
            ],
          },
        ],
        RightSections: [
          {
            Header: 'Topic C6 — The Rate and Extent of Chemical Change',
            Subcategories: [
              {
                Name: 'Factors Affecting Rates of Reaction',
                ShortName: 'Factors-Affecting-Rates-of-Reaction',
                Link: 'https://www.youtube.com/embed/i9g9CE4EVOc?rel=0&modestbranding=1',
              },
              {
                Name: 'Graphs of Reaction Rate Experiments',
                ShortName: 'Graphs-of-Reaction-Rate-Experiments',
                Link: 'https://www.youtube.com/embed/nc5-vLk_LY4?rel=0&modestbranding=1',
              },
              {
                Name: 'Reversible Reactions',
                ShortName: 'Reversible-Reactions',
                Link: 'https://www.youtube.com/embed/WjS2XRC2_Yo?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic C7 — Organic Chemistry',
            Subcategories: [
              {
                Name: 'Hydrocarbons',
                ShortName: 'Hydrocarbons',
                Link: 'https://www.youtube.com/embed/kXaqawxplJc?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic C9 — Chemistry of the Atmosphere',
            Subcategories: [
              {
                Name: 'Greenhouse Gases and Climate Change',
                ShortName: 'Greenhouse-Gases-and-Climate-Change',
                Link: 'https://www.youtube.com/embed/tpZ_62wsOm0?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic C10 — Using Resources',
            Subcategories: [
              {
                Name: 'Finite and Renewable Resources',
                ShortName: 'Finite-and-Renewable-Resources',
                Link: 'https://www.youtube.com/embed/1U7fi1M2eiM?rel=0&modestbranding=1',
              },
              {
                Name: 'Using Life Cycle Assessments',
                ShortName: 'Using-Life-Cycle-Assessments',
                Link: 'https://www.youtube.com/embed/fFXtajn8kG4?rel=0&modestbranding=1',
              },
              {
                Name: 'Waste Water Treatment',
                ShortName: 'Waste-Water-Treatment',
                Link: 'https://www.youtube.com/embed/oPHGt5TS-Ho?rel=0&modestbranding=1',
              },
            ],
          },
        ],
      },
      {
        CombinedMenuItemType: CombinedMenuItemTypeEnum.Physics,
        Title: 'Video Solutions',
        Intro:
          "CGP\'s friendly experts are here to walk you through some of the exam-style questions in your book — have a go at the questions first and use these videos if you need a bit of extra help.",
        LeftSections: [
          {
            Header: 'Topic P1 — Energy',
            Subcategories: [
              {
                Name: 'Conservation of Energy and Energy Transfers',
                ShortName: 'Conservation-of-Energy-and-Energy-Transfers',
                Link: 'https://www.youtube.com/embed/eBKrEQLCBfs?rel=0&modestbranding=1',
              },
              {
                Name: 'Reducing Unwanted Energy Transfers',
                ShortName: 'Reducing-Unwanted-Energy-Transfers',
                Link: 'https://www.youtube.com/embed/mMepPtkOisQ?rel=0&modestbranding=1',
              },
              {
                Name: 'Hydro-electricity, Waves and Tides',
                ShortName: 'Hydro-electricity-Waves-and-Tides',
                Link: 'https://www.youtube.com/embed/AcqF61bpNok?rel=0&modestbranding=1',
              },
              {
                Name: 'Trends in Energy Resource Use',
                ShortName: 'Trends-in-Energy-Resource-Use',
                Link: 'https://www.youtube.com/embed/keBp0ZOsCv0?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic P2 — Electricity',
            Subcategories: [
              {
                Name: 'Investigating Resistance',
                ShortName: 'Investigating-Resistance',
                Link: 'https://www.youtube.com/embed/Dw-v6eydZjQ?rel=0&modestbranding=1',
              },
              {
                Name: 'Circuit Devices',
                ShortName: 'Circuit-Devices',
                Link: 'https://www.youtube.com/embed/ifnErzOnJXE?rel=0&modestbranding=1',
              },
              {
                Name: 'The National Grid',
                ShortName: 'The-National-Grid',
                Link: 'https://www.youtube.com/embed/9gxgHiB8VYM?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic P4 — Atomic Structure',
            Subcategories: [
              {
                Name: 'Developing the Model of the Atom',
                ShortName: 'Developing-the-Model-of-the-Atom',
                Link: 'https://www.youtube.com/embed/J7-u4XFz230?rel=0&modestbranding=1',
              },
              {
                Name: 'Nuclear Equations',
                ShortName: 'Nuclear-Equations',
                Link: 'https://www.youtube.com/embed/pRya0hSB_io?rel=0&modestbranding=1',
              },
              {
                Name: 'Half-life',
                ShortName: 'Half-life',
                Link: 'https://www.youtube.com/embed/fs9ylPSOHIw?rel=0&modestbranding=1',
              },
            ],
          },
        ],
        RightSections: [
          {
            Header: 'Topic P5a — Force Basics and Springs',
            Subcategories: [
              {
                Name: 'Weight, Mass and Gravity',
                ShortName: 'Weight-Mass-and-Gravity',
                Link: 'https://www.youtube.com/embed/zT1G9EUinfo?rel=0&modestbranding=1',
              },
              {
                Name: 'Investigating Springs',
                ShortName: 'Investigating-Springs',
                Link: 'https://www.youtube.com/embed/yUpDLToESac?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic P5b — Forces and Motion',
            Subcategories: [
              {
                Name: 'Distance, Displacement, Speed and Velocity',
                ShortName: 'Distance-Displacement-Speed-and-Velocity',
                Link: 'https://www.youtube.com/embed/FAjB9av7pQk?rel=0&modestbranding=1',
              },
              {
                Name: 'Velocity-Time Graphs and Terminal Velocity',
                ShortName: 'Velocity-Time-Graphs-and-Terminal-Velocity',
                Link: 'https://www.youtube.com/embed/ItX-Z2EWTQw?rel=0&modestbranding=1',
              },
              {
                Name: 'Reaction Times',
                ShortName: 'Reaction-Times',
                Link: 'https://www.youtube.com/embed/qJ7VysNK98s?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic P6 — Waves',
            Subcategories: [
              {
                Name: 'Refraction',
                ShortName: 'Refraction',
                Link: 'https://www.youtube.com/embed/b2PdSCKabqs?rel=0&modestbranding=1',
              },
            ],
          },
        ],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.Extras,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'View Extras',
    MixedOnlineTests: [],

    ButtonURL: 'extras',
    HasData: false,
    HeadingText: 'Extra Useful Bits',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      "<p>Printable answers, transcripts, and vocabulary lists — yep, it's all right here.</p>",
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Formula sheets, a periodic table and more!',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    HowToUseThisBook: {
      Text: "We've put together lots of helpful information on how to get the most out of your Revision Guide. And if you've hit any snags, you'll find the answers you need here too.",
      VideoLink: 'https://www.youtube.com/embed/-TqrRoP-g9I?rel=0&modestbranding=1',
    },
    ExtrasOrAnswers: {
      HeaderText: 'Extra Useful Bits',
      ContentMain:
        '<p>Your formula sheets, periodic table and more are below. Take your pick!</p>' +
        '' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/SAFQ43B/PDFs/cgp-gcse-combined-physics-formulas-foundation.pdf" style="color: rgb(20, 148, 212);" target="_blank">Physics Formulas</a></p>' +
        '' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/SAFQ43B/PDFs/cgp-gcse-combined-chemistry-periodictable.pdf" style="color: rgb(20, 148, 212);" target="_blank">The Periodic Table</a></p>' +
        '' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/SAFQ43B/PDFs/cgp-gcse-combinedscience-examhelp-foundation.pdf" style="color: rgb(20, 148, 212);" target="_blank">What to Expect in the Exams</a></p>',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.OnlineEdition,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Your Online Library',
    ButtonURL: '[[external_domain]]/bookspacedemo',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Online Edition',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Use your book wherever you are with your Online Edition — yippee!</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Read your eBook here',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.NeedHelp,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Take a look',
    ButtonURL: '',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Need some help?',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>Watch our useful video to get started or take a look at the FAQs if you need some help.</p>\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Check out our video and FAQs',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      TagLine:
        'We’ve put together lots of helpful information on how to get the most out of your Exam Practice Workbook. And if you’ve hit any snags, you’ll find the answers you need here too.',
      Text:
        '<div class="free-content">\n' +
        '            <h2>Frequently Asked Questions</h2>\n' +
        '\n' +
        '<h5><strong>What is CGP RevisionHub?  &nbsp;</strong></h5>\n' +
        '\n' +
        '<p>Great question! CGP RevisionHub is our online platform where you can find lots of helpful revision, all matched to your GCSE Science Workbooks. Use the quizzes, tests, videos and more to make sure you know your stuff for the exams. &nbsp;<br>\n' +
        '  &nbsp;</p>\n' +
        '\n' +
        '<h5><strong>How do I access CGP RevisionHub?</strong><strong>  &nbsp;</strong></h5>\n' +
        '\n' +
        '<p>You can access CGP RevisionHub on your computer, tablet or phone. Just make sure your device can connect to the internet. Wearing a spinny propellor hat is not required, but it is cool though.  &nbsp;<br>\n' +
        '  &nbsp;</p>\n' +
        '\n' +
        '<h5><strong>How do I use CGP RevisionHub with my book?</strong>  &nbsp;</h5>\n' +
        '\n' +
        "<p>You'll notice lots of QR codes scattered throughout your book. Just give them a scan and you'll automatically be taken to the relevant quiz, video or other revision thingy-ma-jig!  &nbsp;<br>\n" +
        '<strong>  &nbsp;</strong></p>\n' +
        '\n' +
        '<h5><strong>My CGP RevisionHub isn’t working — what do I do?</strong><strong>  &nbsp;</strong></h5>\n' +
        '\n' +
        '<p>If you can’t find the answer in these FAQs, it\'s time to contact our friendly <a href="#contact">Customer Services team</a>.&nbsp;</p>\n' +
        '\n' +
        '<p>You could also ask your friendly neighbourhood psychic, but they will charge...  &nbsp;<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5><strong>Do I need an internet connection to use CGP RevisionHub?  &nbsp;</strong></h5>\n' +
        '\n' +
        "<p>Yes, you do. But don't cancel your revision retreat to a remote mountain cave just yet — there are also useful bits that you can download as PDFs to access offline. Phew.  &nbsp;<br>\n" +
        '  &nbsp;</p>\n' +
        '\n' +
        '<h5><strong>If I log in on a different device, will all my progress be saved?</strong><strong>  &nbsp;</strong></h5>\n' +
        '\n' +
        '<p>Yep. Just log in on your computer, tablet or phone, and all your progress and stats will be there waiting for you.  &nbsp;<br>\n' +
        '  &nbsp;</p>\n' +
        '\n' +
        '<h5><strong>What’s the difference between the Quick Quizzes and Your Mistakes Quiz?</strong><strong>  &nbsp;</strong></h5>\n' +
        '\n' +
        "<p>Quick Quizzes are...well, quick! They're a speedy way to test yourself on all the maths skills you’ll need for the course. There are quizzes covering maths skills for Paper 1 and Paper 2 for each subject.  &nbsp;</p>\n" +
        '\n' +
        "<p>Your Mistakes Quiz tests you on any questions you got wrong in your Quick Quizzes. It's really helpful for targeting those bits you find trickier. &nbsp;<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5><strong>How do I use the Online Workbook?</strong><strong>  &nbsp;</strong></h5>\n' +
        '\n' +
        '<p>All the questions from your book are available to answer again online and you can filter them by paper or by type, e.g. Practical Skills. There’s also a QR code on each page of your book that will take you directly to the questions for that page. You’ll mark some of the questions yourself by looking at the answers, and the rest are marked automatically in CGP RevisionHub — wow!<br>\n' +
        '<strong> &nbsp;</strong></p>\n' +
        '\n' +
        '<h5><strong>Can I clear my progress so far in CGP RevisionHub and start again?</strong><strong>  &nbsp;</strong></h5>\n' +
        '\n' +
        '<p>You can reset your answers in the Online Workbook any time you like! There are no takie-backsies in the quizzes though, so you can’t wipe your results and start again from scratch. But practice makes perfect, and you can take the quizzes as many times as you want to improve your scores. Keep going, we believe in you!  &nbsp;<br>\n' +
        '  &nbsp;</p>\n' +
        '\n' +
        '<h5><strong>Can I share my quiz scores and test results with other people?</strong><strong>  &nbsp;</strong></h5>\n' +
        '\n' +
        "<p>You can't share results directly via CGP RevisionHub, but there are other means… Carrier pigeons and smoke signals are both great options. Or you could just tell them, but where's the fun in that?  &nbsp;<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5><strong>What happens when I’ve answered all the questions?</strong><strong>  &nbsp;</strong></h5>\n' +
        '\n' +
        "<p>Ah, one of life's greatest questions — what next? We'd recommend that you keep practising right up until your exams. You’ve got this.&nbsp;<br>\n" +
        '  &nbsp;</p>\n' +
        '\n' +
        '<h5><strong>Will I always have access to CGP RevisionHub?</strong><strong>  &nbsp;</strong></h5>\n' +
        '\n' +
        "<p>Once you activate the code in the front of your book, you'll have access for three years. And they’ll be three whole years of bliss, we promise.<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '        </div>',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: sharedMenuBar,
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.MoreFromCGP,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'See more CGP revision',
    ButtonURL: '[[external_domain]]/secondary-books/gcse',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'More from CGP',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      "There's plenty more revision where this came from. Take a look at some of our other books!",
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Everything you need for revision!',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [],
    HowToRevise: {
      DisplayName: 'GCSE Combined Science',
      BookType: 'Revision Guide',
      AdditionalText: "(you'll find some excellent jokes along the way)",
    },
  },
];

